import React, { useEffect, useState } from "react";
import { Post } from "../";
import { db } from "../../firebase";
import LazyLoad from 'react-lazyload';

import "./style.css";

const Feed = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    db.collection("posts")
      .orderBy("timestamp")
      .onSnapshot((snapshot) => {
        setPosts(
          snapshot.docs.map((doc) => ({ id: doc.id, post: doc.data() }))
        );
      });
  }, []);

  return (
    <div className="feed">
      {posts
        .map(({ id, post }) => (
          <LazyLoad key={id} placeholder={"Loading"}> 
          <Post
            key={id}
            postId={id}
            userName={post.userName}
            userEmail={post.userEmail}
            userPhoto={post.userImage}
            userPostText={post.text}
            postPhoto={post.image}
            postVideo={post.video}
            postDateTime={post.timestamp}
            postComments={post.comments}
          />
          </LazyLoad>
        ))
        .reverse()}
    </div>
  );
};

export default Feed;
